import { render } from "./Sign.vue?vue&type=template&id=6ea996c5"
import script from "./Sign.vue?vue&type=script&lang=js"
export * from "./Sign.vue?vue&type=script&lang=js"

import "./Sign.vue?vue&type=style&index=0&id=6ea996c5&lang=css"
script.render = render

export default script